const button = "_61bjvp1ir";

export { button };
import "./add-to-course-builder.style.linaria.module.css";
//# sourceMappingURL=add-to-course-builder.style.js.map
